export default "__VITE_PUBLIC_ASSET__56624ca7__"